import React, { useEffect, useState } from "react";

import { fetchMembershipPlans } from "../Redux/actions/membershipActions";
import { useDispatch, useSelector } from "react-redux";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const MembershipSlider = () => {
  const { memberShipPlans, isLoading } = useSelector(
    (state) => state.memberships
  );
  const sliderRef = React.useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isDark, setIsDark] = useState(
    () => document.documentElement.getAttribute("data-theme") === "dark"
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.getAttribute("data-theme") === "dark");
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {

    dispatch(fetchMembershipPlans({ status: 1 }));
  }, []);

  const settings2 = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    draggable: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div 
      className="sticky top-[70px] z-40 transition-all duration-300"
      style={{
        background: isDark ? "rgba(15, 11, 2, 0.9)" : "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px)",
        borderBottom: isDark ? "1px solid rgba(200,150,30,0.2)" : "1px solid rgba(0,0,0,0.05)",
      }}
    >
      {/* Wrapper: relative so arrows can be absolutely positioned left/right */}
      <div className="relative flex items-center max-w-[1400px] mx-auto">

        {/* Left Arrow — pinned to the left edge, always vertically centered */}
        <button
          onClick={() => sliderRef.current.slickPrev()}
          className="absolute left-2 z-10 p-1.5 rounded-full shadow-sm flex-shrink-0 transition-all hover:scale-110"
          style={{ 
            top: "50%", 
            transform: "translateY(-50%)",
            background: isDark ? "rgba(200,150,30,0.15)" : "rgba(0,0,0,0.05)",
            color: isDark ? "#f0c040" : "#189FAA"
          }}
        >
          <MdOutlineKeyboardArrowLeft size={20} />
        </button>

        {/* Slider takes full width with padding to avoid overlap with arrows */}
        <div className="w-full px-12">
          <Slider ref={sliderRef} {...settings2}>
            {memberShipPlans.map((details, i) => (
              <div
                key={i}
                className="cursor-pointer"
                onClick={() => navigate(APP_ROUTES.JOINMEMBERSHIP)}
              >
                <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 py-3 text-center">
                  <span 
                    className="px-3 py-1 rounded-full text-xs font-bold tracking-wide uppercase shadow-sm border transition-all"
                    style={{
                      background: isDark ? "rgba(200,150,30,0.1)" : "rgba(24,159,170,0.05)",
                      borderColor: isDark ? "rgba(200,150,30,0.3)" : "rgba(24,159,170,0.3)",
                      color: isDark ? "#f0c040" : "#189FAA"
                    }}
                  >
                    {details?.description}
                  </span>
                  
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium" style={{ color: isDark ? "#b89a4a" : "#64748b" }}>
                      Plan starts at
                    </span>
                    <span className="text-lg font-bold" style={{ color: isDark ? "#f5e6b0" : "#0f172a" }}>
                      <span className="text-xs mr-1 opacity-70">INR</span>
                      {details?.actualAmount}
                    </span>
                  </div>

                  {details?.upto_Discount_Percent && (
                    <span 
                      className="text-sm font-semibold px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-500 border border-emerald-500/20"
                    >
                      {details?.upto_Discount_Percent}
                    </span>
                  )}

                  <strong 
                    className="text-sm font-bold flex items-center gap-1 hover:gap-2 transition-all"
                    style={{ color: isDark ? "#f0c040" : "#189FAA" }}
                  >
                    View Details <MdOutlineKeyboardArrowRight size={18} />
                  </strong>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Right Arrow — pinned to the right edge, always vertically centered */}
        <button
          onClick={() => sliderRef.current.slickNext()}
          className="absolute right-2 z-10 p-1.5 rounded-full shadow-sm flex-shrink-0 transition-all hover:scale-110"
          style={{ 
            top: "50%", 
            transform: "translateY(-50%)",
            background: isDark ? "rgba(200,150,30,0.15)" : "rgba(0,0,0,0.05)",
            color: isDark ? "#f0c040" : "#189FAA"
          }}
        >
          <MdOutlineKeyboardArrowRight size={20} />
        </button>

      </div>
    </div>

  );
};

export default MembershipSlider;
